import { classNames } from "@/utils/styling-utils";
import ContentLoader from "react-content-loader";
import { HorizontalSpacer } from "../layout/horizontal-spacer";

interface RegisterButtonSkeletonProps {
  length: number;
  size: "small" | "large";
}

export const RegisterButtonSkeleton = ({ length, size }: RegisterButtonSkeletonProps) => {
  const isOddNumber = length % 2 !== 0;
  const isOnlyOne = length === 1;

  return (
    <div
      className={classNames(
        "register-button",
        isOddNumber && "register-button--is-odd-number",
        isOnlyOne && "register-button--is-only-one",
      )}
    >
      {size === "small" ? (
        <ContentLoader viewBox="0 0 380 65" height={65} width={380}>
          <rect width="380" height="65" rx="4" ry="4" />
        </ContentLoader>
      ) : (
        <ContentLoader viewBox="0 0 380 231" height={231} width={380}>
          <rect width="380" height="231" rx="4" ry="4" />
        </ContentLoader>
      )}
      <HorizontalSpacer size="medium" />
    </div>
  );
};
